import {
  Lightning,
  List,
  X,
  WhatsappLogo,
  ArrowRight,
  ArrowLeft,
  Truck,
  MapPin,
  Wallet,
  Buildings,
  DeviceMobile,
  ArrowsClockwise,
  SquaresFour,
  WarningCircle,
  CheckCircle,
  Check,
  Stack,
  FlowArrow,
  Monitor,
  Desktop,
  MapTrifold,
  Fingerprint,
  CurrencyInr,
  HandCoins,
  Plugs,
  CalendarCheck,
  Gear,
  CalendarBlank,
  Users,
  Receipt,
  Package,
  Clock,
  ListChecks,
  ChartBar,
  ChartLine,
  Vault,
  CreditCard,
  Target,
  Database,
  FileText,
  ClipboardText,
  TrendUp,
  PaintBrushBroad,
  ShieldCheck,
  UsersThree,
  Headset,
  Handshake,
  Question,
  CaretUp,
  CaretDown,
  Envelope,
  Phone,
  TwitterLogo,
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  Path,
  Images,
  MagnifyingGlassPlus,
  GlobeHemisphereWest,
  Briefcase,
  CircleNotch,
  UploadSimple,
} from '@phosphor-icons/react';

const iconMap = {
  Lightning,
  List,
  X,
  WhatsappLogo,
  ArrowRight,
  ArrowLeft,
  Truck,
  MapPin,
  Wallet,
  Buildings,
  DeviceMobile,
  ArrowsClockwise,
  SquaresFour,
  WarningCircle,
  CheckCircle,
  Check,
  Stack,
  FlowArrow,
  Monitor,
  Desktop,
  MapTrifold,
  Fingerprint,
  CurrencyInr,
  HandCoins,
  Plugs,
  CalendarCheck,
  Gear,
  CalendarBlank,
  Users,
  Receipt,
  Package,
  Clock,
  ListChecks,
  ChartBar,
  ChartLine,
  Vault,
  CreditCard,
  Target,
  Database,
  FileText,
  ClipboardText,
  TrendUp,
  PaintBrushBroad,
  ShieldCheck,
  UsersThree,
  Headset,
  Handshake,
  Question,
  CaretUp,
  CaretDown,
  Envelope,
  Phone,
  TwitterLogo,
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  Path,
  Images,
  MagnifyingGlassPlus,
  GlobeHemisphereWest,
  Briefcase,
  CircleNotch,
  UploadSimple,
};

export default function PhosphorIcon({
  name,
  size = 24,
  weight = 'duotone',
  className = '',
  ...props
}) {
  const Icon = iconMap[name];
  if (!Icon) return null;
  return <Icon size={size} weight={weight} className={className} {...props} />;
}
